import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { generateRandomId } from '../../others/utils'
import type { AlertComponentType } from './alert.type'

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  public alertEmitter$ = new Subject<{
    id: string;
    message: string;
    progress?: number | null;
    theme: AlertComponentType;
    timeout?: number;
  }>()

  public closeEmitter$ = new Subject<string>()

  public info(message: string, timeout?: number): string {
    const id = generateRandomId()
    this.alertEmitter$.next({
      id,
      message,
      theme: 'info',
      timeout,
    })

    return id
  }

  public success(message: string, timeout?: number): string {
    const id = generateRandomId()

    this.alertEmitter$.next({
      id,
      message,
      theme: 'success',
      timeout,
    })

    return id
  }

  public warning(message: string, timeout?: number): string {
    const id = generateRandomId()
    this.alertEmitter$.next({
      id,
      message,
      theme: 'warning',
      timeout,
    })

    return id
  }

  public error(message: string, timeout?: number): string {
    const id = generateRandomId()
    this.alertEmitter$.next({
      id,
      message,
      theme: 'error',
      timeout,
    })

    return id
  }

  public close(id: string): void {
    this.closeEmitter$.next(id)
  }
}
